import {Module} from "../index";
import ActionScreener from "@/modules/action-screens/services/ActionScreener";

export class ActionScreensModule extends Module {
  public entities = [];

  protected register() {
    super.register();

    this.app.bind<ActionScreener>(ActionScreener).to(ActionScreener).inSingletonScope();
  }

  boot() {
    super.boot();
  }
}
